import { render, staticRenderFns } from "./AgreementSubmitButton.vue?vue&type=template&id=50d01c39&scoped=true&"
import script from "./AgreementSubmitButton.vue?vue&type=script&lang=ts&"
export * from "./AgreementSubmitButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d01c39",
  null
  
)

export default component.exports